import { render, staticRenderFns } from "./StudentsWithVisual.vue?vue&type=template&id=4878d74c&scoped=true&"
import script from "./StudentsWithVisual.vue?vue&type=script&lang=js&"
export * from "./StudentsWithVisual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878d74c",
  null
  
)

export default component.exports